<template>
    <el-dialog
            v-if="addDialogVisible"
            :before-close="handleDialogClose"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
            :destroy-on-close="true"
            :title="editId ? '编辑客户' : '新增客户'"
            :visible.sync="addDialogVisible"
            class="custom_form_dialog custom-form-dialog"
            width="560px">
        <div v-loading="dialogLoading" class="custom_form_body">
            <CustomFormPc
                    v-if="dataLoaded"
                    ref="crm_custom_form"
                    :field_list="formInfoList"
                    :form_detail="formData"
                    :pk_id="pk_id"
                    @submit-form="submitFormData"/>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">发布</el-button>
        </span>
    </el-dialog>
</template>
<script>
    import {
        CustomerPrivateAdd,
        CustomerPrivateEdit,
        CustomerPublicAdd,
        CustomerPublicEdit,
        GetCustomerPublicDetail,
        GetCustomerPrivateDetail,
        getFormFields,
    } from "@/api/index.js";
    import CustomFormPc from "@/components/pComponents/CustomFormPc";

    export default {
        name: "CustomerAdd",
        props: {
            addDialogVisible: {
                type: Boolean,
                default: false,
            },
            editId: "",
            addType: {
                type: String,
                default: "",
            },
            sea_id: "",
        },
        components: {
            CustomFormPc,
        },
        data() {
            return {
                dialogLoading: false,
                loading: false,
                btnDisabled: false,
                owner_uid: this.$store.state.userInfo && this.$store.state.userInfo.user.id,
                owner_name: this.$store.state.userInfo && this.$store.state.userInfo.user.name,
                owner_did: "",
                pk_id: this.editId ? Number(this.editId) : 0,
                formInfoList: [],
                formData: {},
                dataLoaded: false,
            };
        },
        created() {
            this._getFromFields();
        },
        methods: {
            //表单字段获取
            _getFromFields() {
                this.dialogLoading = true;
                getFormFields({
                    field_form: "customers",
                }).then((res) => {
                    if (res.code === 200) {
                        let formInfoList = res.data;
                        if(this.addType === "public") {
                            formInfoList = formInfoList.filter(item=> (item.field_key !== 'salesperson'))
                        } else {
                            formInfoList = formInfoList
                        }
                        this.formInfoList = formInfoList
                        if (this.editId) {
                            if (this.addType === "public") {
                                // 公海
                                GetCustomerPublicDetail(this.editId).then((res) => {
                                    if (res.code === 200) {
                                        this.formData = res.data || {};
                                        this.dialogLoading = false;
                                        this.dataLoaded = true;
                                    } else {
                                        this.$message.error(res.message);
                                    }
                                });
                            } else {
                                // 私海
                                GetCustomerPrivateDetail(this.editId).then((res) => {
                                    if (res.code === 200) {
                                        this.formData = res.data || {};
                                        this.dialogLoading = false;
                                        this.dataLoaded = true;
                                    } else {
                                        this.$message.error(res.message);
                                    }
                                });
                            }
                        } else {
                            this.dialogLoading = false;
                            this.dataLoaded = true;
                        }
                    }
                });
            },
            handleClickAddQuote(url) {
            },

            loadingEnd(loading) {
                this.dialogLoading = loading;
            },
            handleDialogClose() {
                this.$emit("update:addDialogVisible", false);
                this.$nextTick(()=> {
                    // 当从别的页面弹框里面跳转进来，再打开的弹框关闭不了，需要手动移除
                    // 手动移除多余的遮罩层
                    const modals = document.querySelectorAll('.customer-private-seas-detail-wrap .v-modal');
                    const custom_form_dialog = document.querySelectorAll('.customer-private-seas-detail-wrap .custom_form_dialog')
                    if (modals.length == 1 && !custom_form_dialog.length) {
                        modals.forEach(modal => {
                            modal.remove();
                        });
                    }
                })
            },
            handleAddSuccess() {
                this.$emit("update:addDialogVisible", false);
                this.$emit("operateSuccessCallback");
                this.$nextTick(()=> {
                    // 当从别的页面弹框里面跳转进来，再打开的弹框关闭不了，需要手动移除
                    // 手动移除多余的遮罩层
                    const modals = document.querySelectorAll('.customer-private-seas-detail-wrap .v-modal');
                    const custom_form_dialog = document.querySelectorAll('.customer-private-seas-detail-wrap .custom_form_dialog')
                    if (modals.length == 1 && !custom_form_dialog.length) {
                        modals.forEach(modal => {
                            modal.remove();
                        });
                    }
                })

            },
            handleDialogConfirm() {
                this.$refs.crm_custom_form.handleClickPublish();
            },
            submitFormData(customForm) {
                if (customForm) {
                    this.btnDisabled = true;
                    if (this.addType === "public") {
                        // 公海
                        if (this.editId) {
                            CustomerPublicEdit(this.editId, customForm)
                                    .then((res) => {
                                        if (res.code == 200) {
                                            this.$message.success(res.message);
                                            this.handleAddSuccess();
                                        }
                                        this.btnDisabled = false;
                                    })
                                    .catch(() => {
                                        this.btnDisabled = false;
                                    });
                        } else {
                            CustomerPublicAdd({sea_id: this.sea_id, ...customForm})
                                    .then((res) => {
                                        if (res.code == 200) {
                                            this.$message.success(res.message);
                                            this.handleAddSuccess();
                                        }
                                        this.btnDisabled = false;
                                    })
                                    .catch(() => {
                                        this.btnDisabled = false;
                                    });
                        }
                    } else {
                        // 私海
                        if (this.editId) {
                            CustomerPrivateEdit(this.editId, customForm)
                                    .then((res) => {
                                        if (res.code == 200) {
                                            this.$message.success(res.message);
                                            this.handleAddSuccess();
                                        }
                                        this.btnDisabled = false;
                                    })
                                    .catch(() => {
                                        this.btnDisabled = false;
                                    });
                        } else {
                            CustomerPrivateAdd(customForm)
                                    .then((res) => {
                                        if (res.code == 200) {
                                            this.$message.success(res.message);
                                            this.handleAddSuccess();
                                        }
                                        this.btnDisabled = false;
                                    })
                                    .catch(() => {
                                        this.btnDisabled = false;
                                    });
                        }
                    }
                }
            },
        },
    };
</script>
<style lang="scss">
    .custom-customer-dialog {
        .el-dialog__body {
            padding: 0;
            height: 492px;
            overflow-y: scroll;

            & > div {
                height: 100%;
            }
        }
    }

    .custom-form-row {
        .el-cascader {
            width: 100%;
        }

        .form-row-province {
            .el-form-item__content {
                display: flex;

                .el-cascader {
                    width: 180px;
                    flex-shrink: 0;
                    margin-right: 8px;
                }
            }
        }

        .form-row-textarea {
            .el-form-item__content {
                line-height: 22px;
                height: auto;
            }
        }
    }
</style>
